import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import styled from 'styled-components';

import styles from './alert.module.css';

export type AlertTypes = 'info' | 'success' | 'warning' | 'danger';

const CloseIcon = styled.i`
  float: right;
  cursor: pointer;
`;

export type AlertProps = {
  type: AlertTypes;
  message: string;
  onHide?: () => void;
  timeoutInMilliSeconds?: number;
  className?: string | null;
  alertId?: any;
  closeClassName?: string;
};

const Alert: React.FC<AlertProps> = ({
  type,
  message,
  onHide,
  timeoutInMilliSeconds,
  className,
  closeClassName
}) => {
  const [showingAlert, updateShowingAlert] = useState(true);

  useEffect(() => {
    if (timeoutInMilliSeconds) {
      const timer = setTimeout(() => {
        onHide ? onHide() : updateShowingAlert(false);
      }, timeoutInMilliSeconds);
      return () => clearTimeout(timer);
    }
  }, [timeoutInMilliSeconds, onHide]);

  return (
    <div className='row'>
       <div className='col-md-12'><div
      className={cn(
        className,
        'alert',
        `alert-${type}`,
          showingAlert ? styles.message : styles.hidden,
          'd-flex',
      )}
          >
      <div>{message}</div>
      <div className={cn(closeClassName || 'align-items-end', 'd-flex')}>
        <CloseIcon
          onClick={() => {
            onHide ? onHide() : updateShowingAlert(false);
          }}
          className={cn('closeIcon', 'glyphicon', 'glyphicon-remove')}
        />
      </div>
    </div>
  </div>
</div>
  );
};

export default Alert;
